"use client";

import { useState } from "react";
import UserForm from "@/components/waitlist/UserForm";
import FounderForm from "@/components/waitlist/FounderForm";
import InvestorForm from "@/components/waitlist/InvestorForm";
import { User } from "@/types/waitlist/types";

export default function Waitlist() {
  const [navigation, setNavigation] = useState<string>("user");
  const [user, setUser] = useState<User>(null);

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted p-6">
      {navigation === "user" && (
        <UserForm setNavigation={setNavigation} setUser={setUser} />
      )}
      {navigation === "founder" && <FounderForm user={user} />}
      {navigation === "investor" && <InvestorForm user={user} />}
    </div>
  );
}
